import {
  base_colorAction,
  base_colorRaisedSurface,
  cta_buttonPrimaryText,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { pill_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

export default css`
  position: relative;
  height: ${spacing(9)};
  width: ${spacing(9)};

  padding: ${spacing(1)};
  transition: background-color ${pill_transitionSpeed} ease-out;

  &.light-on-dark {
    background-color: transparent;
    svg path {
      stroke: ${cta_buttonPrimaryText};
    }
    &:hover {
      background-color: ${base_colorRaisedSurface};
      svg path {
        stroke: ${base_colorAction};
      }
    }
  }

  &.dark-on-light {
    background-color: ${base_colorRaisedSurface};
    svg path {
      stroke: ${base_colorAction};
    }
    &:hover {
      background-color: ${base_colorAction};
      svg path {
        stroke: ${cta_buttonPrimaryText};
      }
    }
  }
`
